import { render, staticRenderFns } from "./HoverDescription.vue?vue&type=template&id=0806e09e&scoped=true&"
import script from "./HoverDescription.vue?vue&type=script&lang=ts&"
export * from "./HoverDescription.vue?vue&type=script&lang=ts&"
import style0 from "./HoverDescription.vue?vue&type=style&index=0&id=0806e09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806e09e",
  null
  
)

export default component.exports